// extracted by mini-css-extract-plugin
export default {"headerBlock":"service-center_headerBlock__IHe-y","wrapper":"service-center_wrapper__zCluS"};